import './NoNetworkEmptyState.scss';

import React from 'react';
import { colors } from '@pdcfrontendui/components';

export function NoServerEmptyStateImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M165.44994,53.1031197 C184.139255,63.2129398 207.202664,68.0851422 210.914017,79.656623 C214.62537,91.3499089 198.984668,109.986083 193.285089,128.256842 C187.585511,146.527602 191.959606,164.432946 184.669448,174.177351 C177.37929,184.043561 158.424879,185.870636 142.651627,184.043561 C126.878376,182.33829 114.153737,177.100672 95.3318738,177.953307 C76.6425593,178.684138 51.8560216,185.505221 34.4921905,179.536773 C17.2609076,173.568325 7.31978289,154.688541 10.6334911,137.635832 C13.9471994,120.704929 30.5157406,105.357491 38.9988337,86.2340964 C47.6144751,67.1107017 48.2772167,44.0895452 60.0740181,31.0564036 C71.8708194,18.023262 94.9342288,14.8563304 113.623543,21.0683886 C132.312858,27.2804467 146.628077,42.8714945 165.44994,53.1031197 Z"
          fill={colors.colorPrimaryLightest}
          fillRule="nonzero"
          transform="translate(110.7385, 101.3361) rotate(-7.3085) translate(-110.7385, -101.3361)"
        ></path>
        <circle
          fill={colors.colorPrimaryUltraLightest}
          cx="146"
          cy="96"
          r="33"
        ></circle>
        <g transform="translate(65, 70)" fill={colors.colorPrimaryLighter}>
          <rect x="0" y="0" width="80" height="21" rx="6"></rect>
          <rect x="0" y="26" width="80" height="21" rx="6"></rect>
          <rect x="0" y="52" width="80" height="21" rx="6"></rect>
        </g>
        <g
          transform="translate(107, 70)"
          fill={colors.colorPrimaryLight}
          opacity="0.7"
        >
          <path d="M13.5833693,2.01468854 L16.159662,0 L32,0 C35.3137085,-8.8817842e-16 38,2.6862915 38,6 L38,15 C38,18.3137085 35.3137085,21 32,21 L0,21 L0,21 L13.5833693,2.01468854 Z"></path>
          <path d="M1.95186865,29.1561015 L4.72042213,26 L32,26 C35.3137085,26 38,28.6862915 38,32 L38,41 C38,44.3137085 35.3137085,47 32,47 L4,47 L4,47 L1.95186865,29.1561015 Z"></path>
          <path d="M18.4590539,60.8696177 L8.45492385,52 L32,52 C35.3137085,52 38,54.6862915 38,58 L38,63.1207027 L38,63.1207027 L18.4590539,60.8696177 Z"></path>
        </g>
        <path
          d="M176.491089,122.246344 C189.033691,106.138275 187.900454,82.8339015 173.092915,68.0259753 C157.058216,51.9913416 131.060673,51.9913416 115.026025,68.0259753 C98.9913252,84.0606501 98.9913252,110.057897 115.026025,126.092572 C129.833973,140.9006 153.138589,142.033323 169.246681,129.491253 C169.315969,129.569779 169.388336,129.646765 169.463269,129.721699 L191.238578,151.496461 C193.242787,153.50118 196.492634,153.50118 198.496843,151.496461 C200.501052,149.492255 200.501052,146.242926 198.496843,144.238207 L176.722048,122.463445 C176.646601,122.388511 176.569615,122.316144 176.491089,122.246344 Z M165.834137,75.2843319 C177.860418,87.3102867 177.860418,106.808055 165.834137,118.834318 C153.808369,130.860067 134.310314,130.860067 122.284341,118.834318 C110.258316,106.808055 110.258316,87.3102867 122.284341,75.2843319 C134.310314,63.2583258 153.808369,63.2583258 165.834137,75.2843319 Z"
          fill={colors.colorPrimaryDark}
        ></path>
        <g
          transform="translate(75, 77)"
          fill={colors.colorPrimaryBaseDark}
          opacity="0.5"
        >
          <circle cx="3.5" cy="3.5" r="3.5"></circle>
          <circle cx="15.5" cy="3.5" r="3.5"></circle>
          <circle cx="3.5" cy="29.5" r="3.5"></circle>
          <circle cx="15.5" cy="29.5" r="3.5"></circle>
          <circle cx="3.5" cy="55.5" r="3.5"></circle>
          <circle cx="15.5" cy="55.5" r="3.5"></circle>
        </g>
      </g>
    </svg>
  );
}

export default function NoServerEmptyState() {
  return <div className="noNetworkEmptyState">{NoServerEmptyStateImage()}</div>;
}
